/* eslint-disable default-case */
import BaseItemStudyApp from 'es6/controllers/apps/base-item-study-app';
import RapidChoiceQuizDirectionPanel from 'es6/components/apps/settings/rapid-choice-quiz-direction-panel';
import RapidChoiceSequencer from 'es6/controllers/apps/rapid-choice-sequencer';
import { QuizDirection } from 'es6/models/user-settings';
import { t } from 'es6/services/localization';

export default class RapidChoiceApp extends BaseItemStudyApp {

  /**
   * Takes app settings from the app-launcher.
   */
  constructor(appSettings) {
    // Pass to BaseStudyApp for initialization.
    super('rapid_choice', appSettings);

    // Don't load the sentence assets.
    this._includeSentenceAssets = false;
  }

  /**
   * Override the _checkpointTriggered() method.
   *
   * @returns {Boolean}
   */
  _checkpointTriggered() {
    return false;
  }

  /**
   * Creates the sequencer for rapid choice.
   *
   * @returns {RapidChoiceSequencer}
   */
  _createSequencer() {
    return new RapidChoiceSequencer(this._sessionData, this._quizTimer);
  }

  /**
   * @override
   * @returns {Object}
   */
  _getDefaultQuizOptions() {
    return {
      quizDirection: QuizDirection.Forward,
    };
  }

  /**
   * @override
   * @returns {Object}
   */
  _getDefaultSessionConfig() {
    const config = super._getDefaultSessionConfig();

    // Only want to increase the session size.
    config.course.sessionSize = 20;
    config.studyAll.sessionSize = 20;

    return config;
  }

  /**
   * Override default session sizes.
   *
   * @returns {Number[]}
   */
  _getSessionSizes() {
    return [10, 20, 50, 100];
  }

  /**
   * Add settings panel that are specific to rapid choice.
   *
   * @returns {Array}
   */
  _getSettingsPanels() {
    const panels = super._getSettingsPanels();

    // Add the iKnow quiz settings panel.
    panels.splice(1, 0, RapidChoiceQuizDirectionPanel);

    return panels;
  }

  /**
   * Add study parameters that are specific to rapid choice.
   *
   * @returns {Object}
   */
  _getStudyParameters() {
    const params = super._getStudyParameters();
    const quizOptions = this._userSettings.apps.rapidChoice.quizOptions;

    switch (quizOptions.quizDirection) {
      case QuizDirection.Forward:
        params.sequenceOptions.push('no_reverse_rapid_choice');
        break;
      case QuizDirection.Reverse:
        params.sequenceOptions.push('no_forward_rapid_choice');
        break;
    }

    return params;
  }

  /**
   * @override
   * @returns {String}
   */
  _getStartButtonLabel() {
    return t('memory-bank-screen.start-rapid-choice');
  }
}
